export const coveragePlans = {
  PREMIUM: {
    name: 'Plan Premium',
    uri: 'premium',
    color: '#7DF0BA',
  },
  TOTAL: {
    name: 'Plan Total',
    uri: 'total',
    color: '#FFE379',
  },
  STANDAR: {
    name: 'Plan Antiguo',
    uri: '',
    color: '',
  },
  open: {
    name: 'Plan Premium',
    uri: 'premium',
    color: '#7DF0BA',
  },
};
